import { PortfolioMilestone, Study } from '@models';

export interface ColumnConfig {
  displayName: string;
  hasCustomContent: boolean;
  hasHeaderMenu: boolean;
  isSticky: boolean;
}

export const columnConfigurations: Partial<Record<keyof Study, ColumnConfig>> = {
  clientName: {
    displayName: 'Sponsor/Client',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: true
  },
  protocolNumber: {
    displayName: 'Protocol number',
    hasCustomContent: true,
    hasHeaderMenu: false,
    isSticky: true
  },
  bcNumber: {
    displayName: 'BC number',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  studyStage: {
    displayName: 'Stage',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  sitesActivated: {
    displayName: 'Sites activated',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  subjectsEnrolled: {
    displayName: 'Subjects enrolled',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  nextMilestone: {
    displayName: 'Next milestone',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  milestoneStatus: {
    displayName: 'Milestone status',
    hasCustomContent: true,
    hasHeaderMenu: true,
    isSticky: false
  },
  studyPhase: {
    displayName: 'Phase',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  therapeuticArea: {
    displayName: 'Therapeutic area',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  indication: {
    displayName: 'Indication',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  drugName: {
    displayName: 'Drug/asset',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  studyStatus: {
    displayName: 'Status',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  accelerator: {
    displayName: 'Accelerator',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  fspIndicator: {
    displayName: 'FSP Study',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  country: {
    displayName: 'Country',
    hasCustomContent: true,
    hasHeaderMenu: true,
    isSticky: false
  },
  ppdRegion: {
    displayName: 'Region',
    hasCustomContent: true,
    hasHeaderMenu: true,
    isSticky: false
  }
  // region: {
  //   displayName: 'Region',
  //   hasCustomContent: true,
  //   hasHeaderMenu: false,
  //   isSticky: false
  // },
  // studyHealthScore: {
  //   displayName: 'Study health score',
  //   hasCustomContent: false,
  //   hasHeaderMenu: true,
  //   isSticky: false
  // },
  // spendToBudgetScore: {
  //   displayName: 'Spend-to-budget score',
  //   hasCustomContent: false,
  //   hasHeaderMenu: true,
  //   isSticky: false
  // },
};

export const columnConfigurationsMilestones: Partial<
  Record<keyof PortfolioMilestone, ColumnConfig>
> = {
  parentClientName: {
    displayName: 'Sponsor/Client',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  protocolNumber: {
    displayName: 'Protocol number',
    hasCustomContent: true,
    hasHeaderMenu: true,
    isSticky: false
  },
  milestoneName: {
    displayName: 'Milestone name',
    hasCustomContent: true,
    hasHeaderMenu: true,
    isSticky: false
  },
  status: {
    displayName: 'Status',
    hasCustomContent: true,
    hasHeaderMenu: true,
    isSticky: false
  },
  baselineDate: {
    displayName: 'Baseline date',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  plannedDate: {
    displayName: 'Planned date',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  actualDate: {
    displayName: 'Actual date',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  varianceFromBaselineDays: {
    displayName: 'Variance from baseline (days)',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  }
};
